module.exports = __webpack_public_path__ + "img/teacher3.4d9f1357.jpg";